const AVATAR_CLASSES = [
  'bg-violet-100 text-violet-700',
  'bg-fuchsia-100 text-fuchsia-700',
  'bg-sky-100 text-sky-700',
  'bg-emerald-100 text-emerald-700',
  'bg-amber-100 text-amber-700',
];

export function avatarClass(key) {
  const text = String(key || '');
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) hash = (hash + text.charCodeAt(i) * (i + 1)) % 997;
  return AVATAR_CLASSES[hash % AVATAR_CLASSES.length];
}

export function memberInitials(member) {
  const a = String(member?.prenom || member?.label || '').trim().charAt(0);
  const b = String(member?.nom || '').trim().charAt(0);
  const initials = `${a}${b}`.toUpperCase();
  return initials || '•';
}

export function memberRole(member) {
  const role = member?.fonctionMetier?.trim();
  return role || 'Professionnel';
}
